// .. /components/seatmaps/Basic.js

import React, { useState, useEffect, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

//import arena from "./arena.json"; // 1111
import { seatMap as STATIC_SEATMAP } from "./edited.js"; //2222

export default function Basic({ onSelect, seatCategoryPrices, seatsFromApi, reservedSeats = [], canvasSize, scaleConfig, stage }) {

    //const seats = arena;
    //const seatMap = arena.map((s) => ({ // 1111
    //const seatMap = seatsFromApi.map((s) => ({
    const seatMap = STATIC_SEATMAP.map((s) => ({ //2222
        id: s.id,
        import_key: s.import_key,
        label: s.label,
        row: Number(s.row),
        col: Number(s.col ?? 0),
        category: s.category,
        isSpacer: s.isSpacer,
        isVisibleSpacer: s.isVisibleSpacer ?? false,
        name: s.name,
        angle: Number(s.angle ?? 0),
        sector: s.sector,
        tooltipRow: s.tooltipRow ?? null,
    }));

    //console.log("🪑 Bejövő seatStocks:", seatStocks);

    const mappedSeats = seatMap.map((seat) => {
        // 👇 látható spacer / sorjelölő
        if (seat.isVisibleSpacer) {
            return {
                ...seat,
                status: "label",
                isSelectable: false,
            };
        }

        // ⛔ category unavailable
        if (seat.category === "unavailable") {
            return {
                ...seat,
                status: "unavailable",
                isSelectable: false,
            };
        }

        const entry = reservedSeats.find(r => r.seatId === seat.id);

        let status = "available";

        if (entry) {
            if (entry.status === "mine") status = "reserved-mine";   // saját kosár
            if (entry.status === "other") status = "reserved-other"; // más kosár
        }

        return {
            ...seat,
            status,
            isSelectable: true
        };
    });

    const angles = [...new Set(mappedSeats.map(s => s.angle ?? 0))];

    const maxRow = Math.max(...mappedSeats.map((s) => s.row));
    const maxCol = Math.max(...mappedSeats.map((s) => s.col));

    // ➕ Sor eleji sorszám hozzáadása
    const mappedSeatsWithRowLabels = [];

    for (let row = 1; row <= maxRow; row++) {
        // Bal oldali sorszám
        mappedSeatsWithRowLabels.push({
            id: `row-start-${row}`,
            isRowLabel: true,
            row,
            col: 0,
            label: `${row}`,
        });

        // Ülések
        mappedSeats
            .filter((s) => s.row === row)
            .forEach((s) => mappedSeatsWithRowLabels.push(s));

        // Jobb oldali sorszám
        mappedSeatsWithRowLabels.push({
            id: `row-end-${row}`,
            isRowLabel: true,
            row,
            col: maxCol + 1,
            label: `${row}`,
        });
    }

    // 🎭 PÉLDA SZÍNPAD
    const STAGE = stage ?? null;

    function categoryColorStyle(category) {
        switch (category) {
            case "vip":
                return { backgroundImage: "linear-gradient(to right, #14b8a6, #34d399, #0e7490)", color: "#fff" };
            case "premium":
                return { backgroundColor: "#6D28D9", color: "#fff" };
            case "first":
                return { backgroundColor: "#4F46E5", color: "#fff" };
            case "second":
                return { backgroundColor: "#F59E0B", color: "#222" };
            case "third":
                return { backgroundColor: "#22C55E", color: "#222" };
            case "normal":
                return { backgroundColor: "#38BDF8", color: "#222" };
            case "stairs":
                return { backgroundColor: "#D1D5DB", color: "#222" };
            default:
                return { backgroundColor: "#86EFAC", color: "#14532d" };
        }
    }


    // Kijelzőméret alapján állítjuk be a kezdeti térkép nagyítását

    const DEFAULT_SCALE_CONFIG = [
        { maxWidth: 480, scale: 0.05 },
        { maxWidth: 640, scale: 0.05 },
        { maxWidth: 768, scale: 0.05 },
        { maxWidth: 1024, scale: 0.05 },
        { maxWidth: 1440, scale: 0.05 },
        { maxWidth: Infinity, scale: 0.2 },
    ];

    const [initialScale, setInitialScale] = useState(null);

    useEffect(() => {
        const config = scaleConfig ?? DEFAULT_SCALE_CONFIG;

        const updateScale = () => {
            const width = window.innerWidth;

            const matched = config.find(c => width < c.maxWidth);

            if (matched) {
                setInitialScale(matched.scale);
            }
        };

        updateScale(); // első rendernél
        window.addEventListener("resize", updateScale); // újraszámolás ablakméret-változásra
        return () => window.removeEventListener("resize", updateScale); // cleanup
    }, [scaleConfig]);



    // VÉGE
    const isTouch = useIsTouchDevice();

    function useIsTouchDevice() {
        const [isTouch, setIsTouch] = useState(false);

        useEffect(() => {
            setIsTouch(
                // alap touch detection
                'ontouchstart' in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0
            );
        }, []);

        return isTouch;
    }

    // Húzás közben ne jelöljünk ki ülést

    function useDragPreventClick() {
        const [preventClick, setPreventClick] = useState(false);
        const start = useRef({ x: 0, y: 0 });

        const onMouseDown = (e) => {
            start.current = { x: e.clientX, y: e.clientY };
        };

        const onMouseUp = (e) => {
            const dx = Math.abs(e.clientX - start.current.x);
            const dy = Math.abs(e.clientY - start.current.y);
            if (dx > 5 || dy > 5) {
                setPreventClick(true);
                setTimeout(() => setPreventClick(false), 100); // kis késleltetés
            }
        };

        return { preventClick, onMouseDown, onMouseUp };
    }


    const { preventClick, onMouseDown, onMouseUp } = useDragPreventClick();

    const angleConfig = {
        45: {
            fromRow: 0,
            offset: 0,
            rightOffset: 0,
        },
        0: {
            fromRow: 0,
            offset: 0,
            rightOffset: 0,
        },
        315: {
            fromRow: 0,
            offset: 0,
            rightOffset: 0,
        }
    };

    return (
        <div className="overflow-hidden">
            {/* Ülőhelytérkép konténer */}
            <div className="h-[80vh] md:h-screen 2xl:h-[60vh] max-w-full flex items-center justify-center overflow-hidden">
                {/* TransformWrapper és tartalom... */}
                {initialScale !== null && (
                    <TransformWrapper
                        initialScale={initialScale}
                        minScale={0.04}
                        maxScale={4}
                        centerOnInit
                        doubleClick={{ disabled: true }}
                        wheel={{
                            wheelDisabled: true,
                            activationKeys: ['Control', 'Meta', 'Alt'], // ⬅️ csak Ctrl-ra engedélyezi a zoomot
                        }}
                        panning={{
                            disabled: isTouch,             // alapból tiltsuk
                            touch: "two-finger",        // csak két ujjal lehessen panning
                            velocityDisabled: true
                        }}
                    >
                        <TransformComponent wrapperStyle={{ width: "100%", height: "100%", touchAction: "pan-y", }}>
                            <div className="flex items-start justify-center">
                                <div
                                    className="
    inline-block border rounded
    bg-gray-50 dark:bg-zinc-900
    border-gray-300 dark:border-zinc-700
"
                                    style={{
                                        width: canvasSize.width,
                                        height: canvasSize.height,
                                    }}
                                >

                                    {/* 🎭 SZÍNPAD (példa) */}
                                    <div
                                        className="
        absolute flex items-center justify-center
        bg-gray-800 dark:bg-zinc-700
        text-white text-xl font-bold
        shadow-lg
        pointer-events-none
    "
                                        style={{
                                            left: STAGE.x === 0 ? "50%" : STAGE.x,
                                            top: STAGE.y,
                                            width: STAGE.width,
                                            height: STAGE.height,
                                            borderRadius: STAGE.shape === "circle" ? "50%" : "8px",
                                            transform: `
            translateX(${STAGE.x === 0 ? "-50%" : "0"})
            rotate(${STAGE.rotation}deg)
        `,
                                            zIndex: 10,
                                        }}
                                    >
                                        {STAGE.label}
                                    </div>



                                    {/* 💺 ÚJ RENDER – csak a forgatott / absolute seatmap */}
                                    {angles.map(angle => {
                                        const config = angleConfig[angle] || {};
                                        const fromRow = config.fromRow ?? 1;

                                        const seatsForAngle = mappedSeats.filter(s =>
                                            s.angle === angle &&
                                            s.row >= fromRow
                                        );

                                        if (seatsForAngle.length === 0) return null;

                                        // --- Offset számolás (1:1 a második példából) ---
                                        const radOut = (angle + 90) * Math.PI / 180;
                                        const outX = Math.cos(radOut) * (config.offset ?? 0);
                                        const outY = Math.sin(radOut) * (config.offset ?? 0);

                                        const radLeft = (angle + 180) * Math.PI / 180;
                                        const leftX = Math.cos(radLeft) * (config.leftOffset ?? 0);
                                        const leftY = Math.sin(radLeft) * (config.leftOffset ?? 0);

                                        const radRight = (angle + 0) * Math.PI / 180;
                                        const rightX = Math.cos(radRight) * (config.rightOffset ?? 0);
                                        const rightY = Math.sin(radRight) * (config.rightOffset ?? 0);

                                        const translateX = outX + leftX + rightX;
                                        const translateY = outY + leftY + rightY;

                                        return (
                                            <div
                                                key={angle}
                                                className="absolute left-1/2 top-1/2"
                                                style={{
                                                    transform: `
            translate(-50%, -50%)
            translateX(${translateX}px)
            translateY(${translateY}px)
        `
                                                }}
                                            >
                                                {/* 🔴 PIROS PÖTTY a forgatási középpontban */}
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        width: "10px",
                                                        height: "10px",
                                                        background: "red",
                                                        borderRadius: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        zIndex: 9999,
                                                        pointerEvents: "none",
                                                        left: "50%",
                                                        top: "50%",
                                                    }}
                                                />

                                                {/* 💫 csak itt történik a FORGATÁS */}
                                                <div style={{ transform: `rotate(${angle}deg)` }}>
                                                    <div className="relative"
                                                        style={{
                                                            left: "50%",
                                                            transform: "translateX(-50%)"
                                                        }}
                                                    >

                                                        {seatsForAngle.map((seat) => (
                                                            <button
                                                                key={seat.id}
                                                                title={`ROW: ${seat.row} / ANGLE: ${seat.angle} / IMPKEY: ${seat.import_key} / COL: ${seat.col} / ID: ${seat.id} / SECTOR: ${seat.sector}, TOOLTIPROW: ${seat.tooltipRow ?? "n/a"}`}
                                                                onMouseDown={onMouseDown}
                                                                onMouseUp={onMouseUp}
                                                                onClick={() => {
                                                                    if (!preventClick && seat.isSelectable) {
                                                                        onSelect(seat.id);
                                                                    }
                                                                }}
                                                                style={{
                                                                    position: "absolute",
                                                                    left: seat.col * 40 - 16,
                                                                    top: (seat.row - 1) * 45,
                                                                    ...(seat.status === "available"
                                                                        ? categoryColorStyle(seat.category)
                                                                        : {})
                                                                }}
                                                                className={`
                            w-8 h-8 text-xs font-medium border flex items-center justify-center transition

                            ${seat.status === "reserved-mine"
                                                                        ? "bg-yellow-300 dark:bg-yellow-800 text-yellow-900 dark:text-yellow-100"
                                                                        : seat.status === "reserved-other"
                                                                            ? "bg-gray-300 dark:bg-zinc-700 text-gray-500 dark:text-zinc-300 opacity-70"
                                                                            : seat.status === "unavailable"
                                                                                ? "bg-gray-200 dark:bg-zinc-800 text-gray-400 dark:text-zinc-500 opacity-40 cursor-not-allowed"
                                                                                : seat.status === "available"
                                                                                    ? ""
                                                                                    : "bg-white dark:bg-zinc-800 text-gray-900 dark:text-gray-100"
                                                                    }
                        `}
                                                            >
                                                                {seat.label}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}



                                </div>

                            </div>
                        </TransformComponent>
                    </TransformWrapper>
                )}
            </div>
        </div>
    );
}